import store from '../store'

import { getStorage, setStorage } from './stroage/stroage'

import {
  __SYSTEM_CONFIG__,
  __DICT__,
  __SYSTEM_NOTICE__,
  __BANK__,
  __VC_LIST__,
  __TRADE_CONFIG__,
  __BANNER__,
  __LOCALE_LIST__
} from './stroage/nameSpace'

/***
 * 缓存信息Key
 * @type {{SYS_CONFIG: string}}
 */
export const CACHE_INFO_KEYS = {
  SYS_CONFIG: 'SYS_CONFIG',
  SYS_NOTICE: 'SYS_NOTICE',
  VC_TIMING_TRADE_CONFIG: 'VC_TIMING_TRADE_CONFIG',
  BANKS: 'BANK',
  VC: 'VC',
  SYS_BANNER: 'SYS_BANNER',
  I18N_LANGUAGE: 'I18N_LANGUAGE'
}

/***
 * 可缓存对象key与缓存信息对象映射Key
 * @type {{}}
 */
export const CACHE_KEYS_MAP = {
  [ __DICT__ ]: CACHE_INFO_KEYS.SYS_CONFIG,
  [ __SYSTEM_CONFIG__ ]: CACHE_INFO_KEYS.SYS_CONFIG,
  [ __SYSTEM_NOTICE__ ]: CACHE_INFO_KEYS.SYS_NOTICE,
  [ __BANK__ ]: CACHE_INFO_KEYS.BANKS,
  [ __VC_LIST__ ]: CACHE_INFO_KEYS.VC,
  [ __TRADE_CONFIG__ ]: CACHE_INFO_KEYS.VC_TIMING_TRADE_CONFIG,
  [ __BANNER__ ]: CACHE_INFO_KEYS.SYS_BANNER,
  [__LOCALE_LIST__]: CACHE_INFO_KEYS.I18N_LANGUAGE
}

/***
 * 默认激活刷新的缓存Key列表
 * @type {string[]}
 */
const ALWAYS_ACTIVE_CACHES = [
  CACHE_INFO_KEYS.SYS_CONFIG
]

/***
 * 缓存Key对应的state中的action名映射
 * @type {{}}
 */
const DISPATCH_NAME_IN_CACHE_KEY = {
  [ CACHE_INFO_KEYS.SYS_CONFIG ]: 'getSysConfigDict'
}

/***
 * 检测是否需要同步cache到store
 * @param cacheInfoRes
 * @returns {boolean}
 */
export function isNeedUpdateCacheInfo (cacheInfoRes) {
  const { cacheInfo } = store.state.app
  if (!cacheInfo || cacheInfoRes.length !== cacheInfo.length) return true
  return !!cacheInfoRes.find(cacheResItem => {
    return cacheInfo.find(cacheInfoItem => {
      return cacheInfoItem.type === cacheResItem.type && cacheInfoItem.finishUpdateTime !== cacheResItem.finishUpdateTime
    })
  })
}

/** *
 * 初始化可缓存对象的初始值
 * @param cacheKey
 * @returns {undefined|any|{finishUpdateTime: string, cacheKey: *, cacheInfoKey: (*|string), value: boolean}}
 */
export function initStateInCacheHas (cacheKey) {
  return getStorage(cacheKey) || {
    cacheKey,
    cacheInfoKey: CACHE_KEYS_MAP[cacheKey] || ''
  }
}

/** *
 * 检查state中对象的版本信息是否正确
 * @param stateObj
 * @returns {boolean}
 */
export function checkCacheVersionIsRight (stateObj) {
  if (!stateObj || !stateObj[`value_${store.getters.locale}`]) return false
  const cacheUpdateTime = stateObj[`value_${store.getters.locale}`].finishUpdateTime
  return !!store.state.app.cacheInfo.find(cacheItem => cacheItem.type === stateObj.cacheInfoKey && cacheItem.finishUpdateTime === cacheUpdateTime)
}

/***
 * 缓存支持缓存版本号的内容
 * @param key
 * @param value
 */
export function cacheObjByKey (key, value) {
  if (!key || !value || !CACHE_KEYS_MAP[key]) return
  const cacheVersion = findTargetUpdateTimeByKey(key)
  const currentCacheInfo = initStateInCacheHas(key)
  const valueKey = `value_${store.getters.locale}`
  const cacheTargetInfo = {
    ...currentCacheInfo,
    cacheKey: key,
    cacheInfoKey: CACHE_KEYS_MAP[key] || '',
    finishUpdateTime: cacheVersion,
    [valueKey]: {
      data: value,
      finishUpdateTime: cacheVersion
    }
  }
  setStorage(key, cacheTargetInfo)
  return cacheTargetInfo
}

/***
 * 根据缓存对象Key查找对应的版本更新时间
 * @param cacheKey
 * @returns {string}
 */
export function findTargetUpdateTimeByKey (cacheKey) {
  return (
    store.state.app.cacheInfo.find(item => {
      return item.type === CACHE_KEYS_MAP[cacheKey]
    }) || { finishUpdateTime: false }
  ).finishUpdateTime
}

/***
 * 缓存信息的处理函数
 * @param cacheRes
 * @returns {Array|*}
 */
export function cacheHandler (cacheRes) {
  if (!cacheRes || !cacheRes.length) return []
  const { cacheInfo } = store.state.app
  if (cacheInfo && cacheInfo.length) {
    return cacheRes.map(currentCacheItem => {
      const findTargetCacheInfo = cacheInfo.find(targetCacheItem => {
        if (currentCacheItem.type === targetCacheItem.type) {
          if (
            currentCacheItem.finishUpdateTime !== targetCacheItem.finishUpdateTime
          ) {
            // 注册全局监听
            if (
              targetCacheItem.type === CACHE_INFO_KEYS.SYS_CONFIG
            ) {
              DISPATCH_NAME_IN_CACHE_KEY[targetCacheItem.type] && store.dispatch(DISPATCH_NAME_IN_CACHE_KEY[targetCacheItem.type], { noCache: true })
            }
          }
          return true
        }
      }) || currentCacheItem
      return ({
        ...findTargetCacheInfo,
        finishUpdateTime: currentCacheItem.finishUpdateTime,
        isActive: findTargetCacheInfo.isActive || false
      })
    })
  } else {
    return cacheRes.map(item => {
      return {
        ...item,
        isActive: !!ALWAYS_ACTIVE_CACHES.find(activeKey => activeKey === item.type)
      }
    })
  }
}

/** *
 * 检查state中对象的版本信息是否正确(未携带语言区分)
 * @param stateObj
 * @returns {boolean}
 */
export function checkCacheVersionWithoutLocaleIsRight (stateObj) {
  if (!stateObj || !stateObj.value) return false
  const cacheUpdateTime = stateObj.finishUpdateTime
  console.log(stateObj)
  return !!store.state.app.cacheInfo.find(cacheItem => cacheItem.type === stateObj.cacheInfoKey && cacheItem.finishUpdateTime === cacheUpdateTime)
}



// WEBPACK FOOTER //
// ./src/utils/cache.js